import { render, staticRenderFns } from "./WriteSafetyIncidentModal.vue?vue&type=template&id=1d1e0420"
import script from "./WriteSafetyIncidentModal.vue?vue&type=script&lang=js"
export * from "./WriteSafetyIncidentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports